// extracted by mini-css-extract-plugin
export default {"button":"Btn_button__nYu9U","primary":"Btn_primary__LrMT9","secondary":"Btn_secondary__AMLGI","formbutton":"Btn_formbutton__lVjUP"};